'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



/*****************
 ** WEBPACK FOOTER
 ** /codebuild/local-cache/custom/71d3c55b2c0a16a9412b9064ca3814b7ded9e99f804f1d30904ff0a04e4602b9/credentials/~/strict-uri-encode/index.js
 ** module id = 19
 ** module chunks = 0
 **/